import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { targetSelectionSearchSchema } from '@/features/operation-package/-components/SelectTargetFlow/-zod-schema';

export const Route = createFileRoute(
  '/_staff/contractor-core/contract-targets',
)({
  validateSearch: zodValidator(targetSelectionSearchSchema),
});
